import styled from '@emotion/styled';

import { Link, useNavigate } from 'react-router-dom';

import { Grid, Card, CardHeader, CardContent, IconButton, Button } from '@mui/material';

import { CardBlockContainer, CardBlock, CardBlockHeader, CardSpacer } from '../../../utils/utilities/CardComponents';

import MultiStatusChip from '../../../utils/utilities/MultiStatusChip';

import SimpleChip from '../../../utils/utilities/SimpleChip';

import { relativeTime, formatPhoneNumber, formatGenericDateTime, formatGenericDate } from '../../../utils/util';

import { BasicFlex } from '../../../utils/Common';


import LocalOfferRoundedIcon from '@mui/icons-material/LocalOfferRounded';
import AccountBoxOutlinedIcon from '@mui/icons-material/AccountBoxOutlined';
import ConfirmationNumberRoundedIcon from '@mui/icons-material/ConfirmationNumberRounded';
import PhoneAndroidRoundedIcon from '@mui/icons-material/PhoneAndroidRounded';
import EditOutlined from '@mui/icons-material/EditOutlined';
import ContentPasteSearchRoundedIcon from '@mui/icons-material/ContentPasteSearchRounded';

import { useQuery } from '@tanstack/react-query';

import { getBillByInventoryId } from '../../Bills/apiService';

// use pageData context
import { usePageData } from '../../../contexts/PageData';

import BillDisplay from '../../../components/Bills/Components/BillDisplay';


const BillTab = () => {
  const { data = {} } = usePageData();

  const { data: bill = {} } = useQuery({
    queryKey: ['bills', 'by_inventory', data?.inventory_id],
    queryFn: () => getBillByInventoryId(data?.inventory_id),
    enabled: !!data?.inventory_id
  })

  let vendor = bill?.vendor || {};

  const customerBlock = [
    {header: "Vendor", icon: <AccountBoxOutlinedIcon fontSize='small' />, info: vendor.full_name},
    {header: "Phone", icon: <PhoneAndroidRoundedIcon fontSize='small' />, info: formatPhoneNumber(vendor.mobile_phone)},
  ]

  const basicBlock = [
    {header: "Bill ID", icon: <ConfirmationNumberRoundedIcon fontSize='small' color="basic" />, info: `#${bill?.bill_num}`},
    {header: "Date", info: relativeTime(bill.date)},
  ]

  const invoiceBlock = [
    {header: "Bill Total",  info: bill.total, dataType: "currency"},
    {header: "Paid Status", info: <MultiStatusChip value={bill.paid_status} values={[{value: "unpaid", label: "Unpaid", status: "error"}, {value: "partially_paid", label: "Partially Paid", status: "warning"}, {value: "paid", label: "Paid", status: "success"}]} />},
    {header: "Paid Amount", info: bill.total_paid, dataType: "currency"},
    {header: "Balance", info: bill.balance, dataType: "currency"},
  ]

  return (
    <Grid container spacing={3}>

      <Grid size={{xs: 12, md: 4}}>
        <Card variant='outlined'>
          <CardHeader title="Invoice Summary" action={<BasicFlex><Link to={`/bills/edit/${bill?.bill_id}`}><IconButton color="secondary"><EditOutlined /></IconButton></Link><Link to={`/bills/view/${bill?.bill_id}`}><IconButton color="tertiary"><ContentPasteSearchRoundedIcon /></IconButton></Link></BasicFlex>} />
          <CardContent>
            <CardBlockContainer>
              {customerBlock.map((block) => (
                <CardBlock key={block.header} {...block} />
              ))}

              <CardSpacer />
              <CardBlockHeader>General Details</CardBlockHeader>
              {basicBlock.map((block) => (
                <CardBlock key={block.header} {...block} />
              ))}

              <CardSpacer />
              <CardBlockHeader>Bill Details</CardBlockHeader>
              {invoiceBlock.map((block) => (
                <CardBlock key={block.header} {...block} />
              ))}
              <CardSpacer />
            </CardBlockContainer>
          </CardContent>
        </Card>
      </Grid>

      <Grid size={{xs: 12, md: 8}}>
        <BillDisplay bill={bill} />
      </Grid>


    </Grid>
  );

};

export default BillTab;